(function () {
  initializeUtilsFunctions();
  executeOnce('notification-component', function () {

    const $notification = document.querySelector('.notification-component');

    function callback(mutationRecord) {
      if(mutationRecord[0].target.classList.contains('active')) {
        setTimeout(()=>{
          mutationRecord[0].target.classList.remove('active');
        }, 5000);
      }
    }
    const observer = new MutationObserver(callback);

    const config = {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"]
    };

    observer.observe($notification, config);



    function closeNotification() {
      $notification.querySelector('.icon').addEventListener('click', (e) => {
        e.currentTarget.parentNode.classList.remove('active', e.currentTarget.parentNode.classList[1]);
      })
    }
    closeNotification();
  });
}());
